import React, { useState, useEffect, useRef } from 'react'

const AnimatedCounter = ({ end, duration = 2000, suffix = '', prefix = '' }) => {
  const [count, setCount] = useState(0)
  const [isVisible, setIsVisible] = useState(false)
  const counterRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true)
        }
      },
      { threshold: 0.5 }
    )

    const currentRef = counterRef.current
    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [isVisible])

  useEffect(() => {
    if (!isVisible) return

    let startTime = null
    const isPercentage = suffix === '%'
    const numericEnd = isPercentage ? 100 : parseFloat(end.toString().replace(/[^0-9.]/g, ''))
    const hasPlus = end.toString().includes('+')
    const hasSlash = end.toString().includes('/')

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime
      const progress = Math.min((currentTime - startTime) / duration, 1)
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      
      let currentCount = easeOutQuart * numericEnd
      
      if (isPercentage) {
        setCount(Math.floor(currentCount))
      } else if (hasPlus || hasSlash) {
        setCount(Math.floor(currentCount))
      } else {
        setCount(Math.floor(currentCount))
      }
      
      if (progress < 1) {
        requestAnimationFrame(animate)
      } else {
        setCount(numericEnd)
      }
    }

    requestAnimationFrame(animate)
  }, [isVisible, end, duration, suffix])

  const displayValue = () => {
    if (suffix === '%') {
      return `${count}${suffix}`
    } else if (end.toString().includes('+')) {
      return `${count}+`
    } else if (end.toString().includes('/')) {
      return end.toString() // Keep 24/7 as is
    }
    return `${prefix}${count}${suffix}`
  }

  return (
    <div ref={counterRef} className="animated-counter">
      {displayValue()}
    </div>
  )
}

export default AnimatedCounter

